import { usePermission } from '@juvare/contact-management/ui/hooks';
export const useAdditionalSteps = () => {
    const { requireAnySystemPermission } = usePermission();
    const sharingOptions = [
        ...(requireAnySystemPermission('allow-create-public-mission')
            ? [
                {
                    icon: 'material-groups',
                    type: 'public',
                    label: 'Public (Everyone)',
                    description: 'Your mission will be launched for public. Click Launch & add shift to finish the step.',
                },
            ]
            : []),
        {
            icon: 'material-group-add',
            type: 'organizations',
            label: 'Organization',
        },
        {
            icon: 'material-group-outlined',
            type: 'groups',
            label: 'Group',
        },
    ];
    return [
        {
            label: 'Volunteers',
            description: 'Who is the mission intended for?',
            form: {
                type: 'form',
                children: [
                    {
                        type: 'contactManagement.accessSharing',
                        key: 'accessSharing',
                        subtitle: 'Volunteer type',
                        disableNotVisible: true,
                        includeByOrgPermission: ['manage-organization', 'manage-members'],
                        validate: {
                            required: true,
                            minOrganizationsLength: 1,
                            minGroupsLength: 1,
                        },
                        sharingOptions,
                        hideOptionButtonsDivider: true,
                    },
                ],
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        },
    ];
};
